<ng-container *ngIf="visible">
  <div *ngIf="created" class="chat-launcher__panel" [class.chat-launcher__panel--hidden]="!open" role="dialog" [attr.aria-hidden]="!open"
    [attr.aria-label]="strings.listTitle">
    <div class="chat-launcher__body">
      <app-chat [widget]="true" [active]="open"></app-chat>
    </div>
  </div>

  <!-- Aviso de mensagem nova (painel fechado): clicar abre a conversa no balão -->
  <div *ngIf="peek && !open && !invitePeek" class="chat-launcher__peek" [class.chat-launcher__peek--new]="peek.isNew" role="status" aria-live="polite"
    (mouseenter)="holdPeek()" (mouseleave)="releasePeek()">
    <button type="button" class="chat-launcher__peek-body" [attr.aria-label]="strings.launcherPeekOpen + ': ' + peek.name" (click)="openPeek()">
      <chat-avatar [src]="peek.photo" [name]="peek.name" [size]="38"></chat-avatar>
      <span class="chat-launcher__peek-text">
        <span class="chat-launcher__peek-top">
          <span class="chat-launcher__peek-name">{{ peek.name }}</span>
          <span *ngIf="peek.isNew" class="chat-launcher__peek-new">{{ strings.launcherNewConversation }}</span>
        </span>
        <span class="chat-launcher__peek-msg">{{ peek.text }}</span>
      </span>
    </button>
    <button type="button" class="chat-launcher__peek-x" [attr.aria-label]="strings.launcherPeekDismiss" (click)="dismissPeek()">
      <chat-icon name="close" [size]="12"></chat-icon>
    </button>
  </div>

  <!-- Contrato 6.3, v8: convite para uma conversa (painel fechado), com Aceitar / Recusar no próprio cartão -->
  <div *ngIf="invitePeek && !open" class="chat-launcher__peek chat-launcher__peek--invite" role="status" aria-live="polite">
    <div class="chat-launcher__peek-body chat-launcher__peek-body--static">
      <chat-avatar [src]="invitePhoto(invitePeek)" [name]="invitePeek.client?.name || invitePeek.by?.name || '?'" [size]="38"></chat-avatar>
      <span class="chat-launcher__peek-text">
        <span class="chat-launcher__peek-top">
          <span class="chat-launcher__peek-new">{{ strings.launcherInvite }}</span>
        </span>
        <span class="chat-launcher__peek-msg chat-launcher__peek-msg--wrap">{{ inviteText(invitePeek) }}<ng-container *ngIf="invitePeek.property?.reference"> · {{ invitePeek.property?.reference }}</ng-container></span>
        <span class="chat-launcher__peek-actions">
          <button type="button" class="chat-launcher__peek-btn chat-launcher__peek-btn--solid" [disabled]="inviteBusy" (click)="acceptInvite()">{{ strings.inviteAccept }}</button>
          <button type="button" class="chat-launcher__peek-btn" [disabled]="inviteBusy" (click)="declineInvite()">{{ strings.inviteDecline }}</button>
        </span>
      </span>
    </div>
    <button type="button" class="chat-launcher__peek-x" [attr.aria-label]="strings.launcherPeekDismiss" (click)="dismissInvite()">
      <chat-icon name="close" [size]="12"></chat-icon>
    </button>
  </div>

  <button type="button" class="chat-launcher__fab" [class.chat-launcher__fab--open]="open" [class.chat-launcher__fab--unread]="badge > 0 && !open" [attr.aria-label]="strings.listTitle"
    [attr.aria-expanded]="open" (click)="toggle()">
    <chat-icon *ngIf="!open" name="chat" [size]="24" [strokeWidth]="2"></chat-icon>
    <chat-icon *ngIf="open" name="close" [size]="22" [strokeWidth]="2"></chat-icon>
    <span *ngIf="badge > 0 && !open" class="chat-launcher__badge">{{ badge > 99 ? '99+' : badge }}</span>
  </button>
</ng-container>
